<template>
  <base-chip v-bind="$props" :color="color || 'secondary'" dark :text="value" v-on="$listeners" />
</template>

<script>
import { VChip } from 'vuetify/lib'

import BaseChip from '@/components/chips/base-chip'

export default {
  name: 'RoleChip',
  components: {
    BaseChip,
  },
  extends: VChip,
}
</script>
